import { useSelector } from 'react-redux';
import { selectors, sliceKeys } from '../../model';
import { useCitiesQuery, citiesSelectors } from '../../api/cities';
import { getBaseOptions } from './helpers';

const { selectCurrentId: selectCompanyId } = selectors[sliceKeys.companies];

const dataTypes = { original: 'original', options: 'options' };

const _options = {
  [dataTypes.original]: {},
  [dataTypes.options]: { select: citiesSelectors.toSelectOption },
};

export const useCitiesData = ({ options, dataType } = {}) => {
  const serviceCompanyId = useSelector(selectCompanyId);

  const baseOptions = getBaseOptions(_options, dataType, dataTypes.original);

  return useCitiesQuery({
    params: { serviceCompanyId },
    options: { ...baseOptions, ...options },
  });
};

useCitiesData.dataTypes = dataTypes;
